import React, { Fragment } from "react";

export const About = () => {
  return (
    <Fragment>
      <h1>ABOUT THIS APP</h1>
      <p className="lead">Search users From Github</p>
      <p className="lead">Version 1.0.0</p>
    </Fragment>
  );
};
export default About;
